module.exports = __webpack_public_path__ + "img/nx.f63d2cf8.jpg";